import _ from "lodash";

import nxModule from 'nxModule';
import {setBreadcrumbs} from '../../shared/utils/set-breadcrumbs';
import { ActionType, Columns } from '../common/dynamic-list/dynamic-list.component';


const templateUrl = require('./dynamic-report-tool-list.template.html');

class DynamicReportToolList {
  constructor($routeParams, http, breadcrumbs, notification, customerCache) {
    this.$routeParams = $routeParams;
    this.http = http;
    this.breadcrumbs = breadcrumbs;
    this.notification = notification;
    this.customerCache = customerCache;
    this.reportList = [];
    this.columns = [
      { title: 'No' },
      { title: 'Product Number', field: 'productNumber' },
      { title: 'Account Name', field: 'accountName' },
      { title: 'Date Range', field: 'dateRange' },
      { title: 'Date Type', field: 'dateType' },
      { title: 'Date Generated', field: 'dateGenerated' },
      { title: 'Status', field: 'status' },
      {
        actions: [{
            label: 'Download',
            field: 'download',
            type: ActionType.BUTTON
        }]
      }
    ];
    this.statusLabelMap = {
      COMPLETED: 'DONE',
      FAILED: 'FAILED',
      IN_PROGRESS: 'IN PROGRESS'
    };
  }
  

  async $onInit() {
    this.customerId = _.get(this.$routeParams, 'customerId');
    this.profile = await this.customerCache.profile(this.customerId, true, true).toPromise();

    setBreadcrumbs(this.breadcrumbs, 'dynamic-report-list', this.reportCode);    
    const reportName = this.reportCode;
    const customerNumber = this.profile?.customerNumber;
    const response = await this.http.get(`/reports/file-reports/dynamic/${reportName}/${customerNumber}`).toPromise();
    this.reportList = response.map((item) => ({
        productNumber: item.productNumber,
        accountName: item.accountName,
        dateRange: item.dateRange.replace(/-/g, '/'),
        dateType: item.systemDate ? 'System Date' : 'Realtime Server Date',
        dateGenerated: this.formatDate(item.dateGenerated),
        status: this.getStatusLabel(item.status),
        download: item.status === 'COMPLETED'
            ? () => this.downloadReport(item)
            : null // Button will be disabled if download is null
    }));
    
    
  };

  formatDate(dateStr) {
    // Assuming dateStr is ISO format, convert to YYYY/MM/DD
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return `${d.getFullYear()}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getDate().toString().padStart(2, '0')}`;
  }

  getStatusLabel(status) {
    return this.statusLabelMap[status] || 'IN PROGRESS';
  }

  downloadReport(item) {
  if (!item.url) return;
  if (item.url.startsWith('data:')) {
    const a = document.createElement('a');
    a.href = item.url;
    a.download = item.reportFileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } else {
    window.open(item.url, '_blank');
  }
}

  goBack() {
    window.history.back();
  }
}

nxModule.component('dynamicReportToolList', {
  templateUrl,
  controller: DynamicReportToolList,
  bindings: {
    reportCode: '<'
  }
});